module.exports = __webpack_public_path__ + "img/logo_chrono_fresh.325c045f.png";